module.exports = __webpack_public_path__ + "img/icon_FAQ_dashboard_inactive.b83b8cdb.svg";